"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentScreenshot = void 0;

var _react = _interopRequireDefault(require("react"));

var _knotchincWebReactComponents = _interopRequireDefault(require("@bit/knotchinc.web-react-components.error"));

var _styled = require("./styled.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ContentScreenshot = function ContentScreenshot(_ref) {
  var thumbnail = _ref.thumbnail,
      onClick = _ref.onClick,
      children = _ref.children,
      maxHeight = _ref.maxHeight;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_styled.ScreenshotPositionContainer, null, /*#__PURE__*/_react["default"].createElement(_styled.ScreenshotContainer, {
    maxHeight: maxHeight
  }, /*#__PURE__*/_react["default"].createElement(_styled.ScreenshotThumbnail, {
    image: thumbnail,
    onClick: onClick
  }, thumbnail ? /*#__PURE__*/_react["default"].createElement(_styled.EyeIcon, null) : /*#__PURE__*/_react["default"].createElement(_knotchincWebReactComponents["default"], {
    noImage: true
  }), children))));
};

exports.ContentScreenshot = ContentScreenshot;

//# sourceMappingURL=ContentScreenshot.js.map